import type { ProviderIcon } from '#layers/access/types/auth-providers/define';

/** Fallback icon for providers without a configured `def.icon`. */
export const FALLBACK_PROVIDER_ICON = 'lucide:key-round';

/**
 * Resolve a provider's `icon` field to a single Iconify name, picking the
 * `dark` variant when configured and the current color mode is dark.
 */
export function resolveProviderIcon(
	icon: string | ProviderIcon | undefined,
	isDark: boolean,
): string {
	if (!icon) return FALLBACK_PROVIDER_ICON;
	if (typeof icon === 'string') return icon;
	return isDark && icon.dark ? icon.dark : icon.default;
}
